import React from "react";
export const createGoogleCampaignTabs = [
  {
    number: 1,
    title: "Name Campaign",
    subTexts: ["Name your Campaign"],
  },
  {
    number: 2,
    title: "Objective",
    subTexts: ["Choose your objective"],
    isToggle: true,
  },
  {
    number: 3,
    title: "Goals",
    subTexts: ["Use these conversion goals to improve Sales", "Add Goals "],
    isToggle: true,
  },
  {
    number: 4,
    title: "Select the ways",
    subTexts: ["Select the ways you'd like to reach your goalhelp_outline"],
  },
  {
    number: 5,
    title: "Ad Name",
    subTexts: ["Partnership ad", "Ad Setup"],
  },
];
export const createCampaignTabs = [
  {
    number: 1,
    title: "Name Campaign",
    subTexts: ["Buying Type", "Choose a Campaign Objective"],
  },
  {
    number: 2,
    title: "Campaign Budget",
    subTexts: ["Campaign Budget", "Campaign Bid Strategy"],
    isToggle: true,
  },
  {
    number: 3,
    title: "AB Testing",
    subTexts: ["What do you want to test?", "Test duration"],
    isToggle: true,
  },
  {
    number: 4,
    title: "Ad Set",
    subTexts: [
      "Awareness",
      "Dynamic creative",
      "Budget & schedule",
      "Audience controls",
      "Advantage+ audience",
      "Placements",
    ],
  },
  {
    number: 5,
    title: "Ad Name",
    subTexts: ["Partnership ad", "Ad Setup"],
  },
];
export const tabContent = {
  Awareness: {
    title: "Awareness",
    description:
      "Show your ads to people who are most likely to remember them.",
    goodFor: [
      "Reach",
      "Brand awareness",
      "Video views",
      "Store location awareness",
    ],
  },
  Traffic: {
    title: "Traffic",
    description:
      "Send people to a destination like your website, app, Instagram profile or Facebook event.",
    goodFor: [
      "Link clicks",
      "Landing page views",
      "Instagram profile visits",
      "Messenger, Instagram and Whatsapp",
      "Calls",
    ],
  },
  Engagement: {
    title: "Engagement",
    description:
      "Get more messages, purchases through messaging, video views, post engagement, page likes or event responses.",
    goodFor: [
      "Messeneger, Instagram or WhatsApp",
      "Video views",
      "Post engagement",
      "Conversations",
      "Calls",
    ],
  },
  Leads: {
    title: "Leads",
    description: "Collect leads for your business or brand.",
    goodFor: [
      "Instant forms",
      "Messeneger and Instagram",
      "Conversations",
      "Calls",
    ],
  },
  AppPromotion: {
    title: "AppPromotion",
    description: "Find new people to install your app and continue using it.",
    goodFor: ["App Installs", "App events"],
  },
  Sales: {
    title: "Sales",
    description: "Find people to purchase your product or service.",
    goodFor: [
      "Conversations",
      "Catalog sales",
      "Messeneger, Instagram or WhatsApp",
      "Calls",
    ],
  },
};
export const previewDevices = [
  {
    type: "pc",
    code: (
      <svg
        className="w-6 h-6 text-white dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 15v5m-3 0h6M4 11h16M5 15h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1Z"
        />
      </svg>
    ),
  },
  {
    type: "Tab",
    code: (
      <svg
        className="w-6 h-6 text-white dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M11 18h2M5.875 3h12.25c.483 0 .875.448.875 1v16c0 .552-.392 1-.875 1H5.875C5.392 21 5 20.552 5 20V4c0-.552.392-1 .875-1Z"
        />
      </svg>
    ),
  },
  {
    type: "Smartphone",
    code: (
      <svg
        className="w-6 h-6 text-white dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          fill-rule="evenodd"
          d="M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4Zm12 12V5H7v11h10Zm-5 1a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
          clip-rule="evenodd"
        />
      </svg>
    ),
  },
];
export const objectives = [
  {
    title: "Sales",
    description: "Drive sales online, in app, by phone, or in store.",
  },
  {
    title: "Leads",
    description:
      "Get leads and other conversions by encouraging customers to take action.",
  },
  {
    title: "Website Traffic",
    description: "Get the right people to visit your website.",
  },
  {
    title: "App promotion",
    description:
      "Get more installs, engagement and pre-registration for your app.",
  },
  {
    title: "Awareness & consideration",
    description:
      "Reach a broad audience and build interest in your products or brand.",
  },
  {
    title: "Local store visits and promotions",
    description:
      "Drive visits to local stores, including restaurants and dealerships.",
  },
  {
    title: "Create a campaign without a goal's guidance",
    description:
      "Choose a campaign type first, without a recommendation based on your objective.",
  },
];
export const Goals = [
  {
    title: "Sales Goal 1",
    subTopic1: "Conversion Goals",
    subTopic2: "Conversion Source",
    subDesc1: "Phone call leads (account default)",
    subDesc2: "Call from Ads",
  },
  {
    title: "Sales Goal 2",
    subTopic1: "Conversion Goals",
    subTopic2: "Conversion Source",
    subDesc1: "Phone call leads (account default)",
    subDesc2: "Call from Ads",
  },
  {
    title: "Sales Goal 3",
    subTopic1: "Conversion Goals",
    subTopic2: "Conversion Source",
    subDesc1: "Phone call leads (account default)",
    subDesc2: "Call from Ads",
  },
  {
    title: "Sales Goal 4",
    subTopic1: "Conversion Goals",
    subTopic2: "Conversion Source",
    subDesc1: "Phone call leads (account default)",
    subDesc2: "Call from Ads",
  },
];
export const CampaignType = [
  {
    title: "Search",
    description:
      "Get in front of high-intent customers at the right time on Google Search",
  },
  {
    title: "Performance Max",
    description:
      "Reach audiences across all of Google with a single campaign. See how it works",
  },
  {
    title: "Demand Gen",
    description:
      "Drive demand and conversions on YouTube, Discover and Gmail with image and video ads",
  },
  {
    title: "Display",
    description:
      "Reach customers across 3 million sites and apps with engaging creative",
  },
  {
    title: "Shopping",
    description:
      "Showcase your products to shoppers as they explore what to buy",
  },
  {
    title: "Video",
    description: "Reach viewers on YouTube and get conversions",
  },
];
